(function () {
    'use strict';

    var module = angular.module('uwAgenda.users');
    module.factory('Website', ['SharedAgendaService', WebsiteFn]);

    /* user website object */
    function WebsiteFn(SharedAgendaService) {
        var Website = function () {

            // define default values
            this.domainName = null;
            this.fK_Language = null;

            // vm
            this.language = null;

        };

        // extend
        Website.prototype.extend = function (object) {
            var self = this;
            angular.extend(self, object);
        };

        // prepare for backend
        Website.prototype.prepareForSave = function () {
            var self = this;

            self.fK_Language = self.language.id;
            self.fK_User = SharedAgendaService.currentUser().id;

            delete self.language;
        };

        return Website;
    }
})();